/*******************************************************************************
 * Copyright (c) 2024. dnote.ai
 *
 * @project DNOTE.AI-Frontend
 * @author dnote.ai
 * @copyright Dnote.ai All rights reserved
 ******************************************************************************/

export const  TEMPLATE_MODEL = {
    name: null,
    templateStyle: null,
    communicationWays: null,
//added date is 08/06/2026
     active: false,

    emailText  : null,
    smsText  : null,
    whatsappTemplate: null,
    bibleVerse : null,
    language: "ENGLISH",
     whatsappTemplateType: null,
    whatsappHeaderUrl: null,
    whatsappHeaderFilename: null,
    whatsappParamCount: 0,
    smsDltTemplateId : null,

}

export const  TEMPLATE_STYLE = [
    { label: "SMS: Receipt", value: "SMS_RECEIPT" },
    { label: "SMS: Promo", value: "SMS_PROMO" },
    //added date is 08/06/2026
    { label: "SMS: Otp", value: "SMS_OTP" },
    { label: "Email: Receipt", value: "EMAIL_RECEIPT" },
    { label: "Email: Other", value: "EMAIL_OTHER" },
    //added date is 08/06/2026
    { label: "Email: Otp", value: "EMAIL_OTP" },
    { label: "Whatsapp: Receipt", value: "WHATSAPP_RECEIPT" },
    { label: "Whatsapp: Other", value: "WHATSAPP_OTHER" }
]

export const MODE_COMMUNICATIONS = [
    {label: "No Way Selected" , value: null},
    {label:"Sms" , value:"SMS"},
    {label:"Mail", value:"MAIL"},
    {label:"Whatsapp", value:"WHATSAPP"}
]

export const WHATSAPP_LANGUAGES = [
    "BENGALI",
    "ENGLISH",
    "GUJARATI",
    "HINDI",
    "KANNADA",
    "MALAYALAM",
    "MARATHI",
    "PUNJABI",
    "TAMIL",
    "TELUGU",
    "URDU"
]

